module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAYCAYAAAACqyaBAAAAxklEQVRIie2WTQ7CIBBGH6Zrr+TCjS44bWPiziN4CS9hmlQXjQ2hwACjdGHfinQYPuavwZDGCnaJXuOsERd9d4rD1Wziq2CAM9CtoP0E/TjVYltF7AY4z37Lmi9+OH/T7YvealXznmmyTI74Adh/UfwB3IGXbwiNmk3YcrGR9fztFzU38paJ0ppLmRiBi1Z8iAiVPg4+Zwwl4lfPOYYh0EQOyct2xKMMcXTWI3AT9p88Lbcfgtlw2Z5RNaR6AcgbtdrUizV9A8X5GqAQbFnYAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/resources/assets/images/printDisable.png
// module id = 484
// module chunks = 0